import { createUseStyles } from 'react-jss'

import { MQ, COLOR, TYPOGRAPHY, Z_INDEX } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: [25, 0, 0],
  },
  productContainer: {
    width: '88%',
    margin: 'auto',
    [MQ.TABLET_LARGE]: {
      width: '75%',
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: 1170,
    },
  },
  image: {
    borderRadius: 20,
    maxWidth: 500,
    margin: 'auto',
    [MQ.TABLET_LARGE]: {
      width: '46%',
      height: '100%',
      margin: 0,
      maxWidth: 'unset',
    },
  },
  textBlock: {
    [MQ.TABLET_LARGE]: {
      width: '40%',
    },
    '& h1': {
      lineHeight: 1,
    },
  },
  title: {
    color: COLOR.LIGHT_GREEN,
    margin: [20, 0, 5],
    [MQ.TABLET_LARGE]: {},
  },
  price: {},
  orderSelectors: {
    margin: [35, 0, 20],
    [MQ.TABLET_LARGE]: {
      display: 'flex',
      marginBottom: 35,
    },
  },
  variantSelectors: {
    [MQ.TABLET_LARGE]: {
      marginLeft: 45,
    },
  },
  quantityTitle: {
    margin: [0, 0, 10, 0],
    display: 'inline-block',
  },
  quantitySelectors: {
    display: 'flex',
    margin: [0, 0, 15],
  },
  quantity: {
    border: `3px solid ${COLOR.LIGHT_GREEN}`,
    borderRadius: '50%',
    width: 45,
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: [0, 10],
    '& p': {
      margin: 0,
    },
  },
  quantityButton: {
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    '& span': {
      color: COLOR.DARK_GREEN,
    },
  },
  variantButton: {
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    width: 45,
    height: 45,
    color: COLOR.DARK_GREEN,
    borderRadius: '50%',
    cursor: 'pointer',
  },
  activeVariant: {
    backgroundColor: COLOR.LIGHT_GREEN,
    color: COLOR.WHITE,
    '& span': {
      fontWeight: 700,
    },
  },
  variantTitle: {
    textTransform: 'uppercase',
    margin: [0, 0, 10],
    display: 'inline-block',
  },
  addToCart: {
    backgroundColor: COLOR.YELLOW,
    border: 'none',
    outline: 'none',
    color: COLOR.WHITE,
    fontSize: 16,
    fontWeight: 400,
    ...TYPOGRAPHY.PROXIMA_NOVA,
    padding: [15, 30],
    borderRadius: 5,
    cursor: 'pointer',
    margin: [10, 0, 5],
    [MQ.TABLET_LARGE]: {
      margin: [10, 0, 5],
    },
    '&:disabled': {
      backgroundColor: COLOR.GREY_2,
      cursor: 'unset',
    },
  },
  details: {
    margin: [30, 0, 5],
    color: COLOR.DARK_GREEN,
  },
  description: {
    color: COLOR.DARK_GREEN,
  },
  backLinkWrapper: {
    margin: [80, 'auto', 60, 'auto'],
    position: 'relative',

    [MQ.TABLET_LARGE]: {
      margin: [150, 'auto', 90, 'auto'],
    },
    '&:before': {
      content: `''`,
      zIndex: Z_INDEX.BACKGROUND,
      position: 'absolute',
      left: '-100vw',
      width: '200vw',
      top: '50%',
      transform: 'translateY(-50%)',
      height: 1,
      backgroundColor: COLOR.LIGHT_GREEN,
    },
  },
  backLink: {
    border: `1px solid ${COLOR.LIGHT_GREEN}`,
    color: COLOR.LIGHT_GREEN,
    backgroundColor: COLOR.WHITE,
    textDecoration: 'none',
    padding: [12, 19],
    borderRadius: 8,
    zIndex: Z_INDEX.CONTENT,
    position: 'relative',
  },
  successMessage: {
    margin: [10, 0, 0],
    [MQ.TABLET_LARGE]: {
      margin: [10, 0, 20],
    },
    '& a': {
      color: COLOR.ORANGE,
      textDecoration: 'none',
    },
  },
})
